import { Component, Input } from '@angular/core';
import { ErzeugungsanlagenImportReport } from '../model/erzeugungsanlagen-import-report';

@Component({
    selector: 'tnb-importreport-display',
    templateUrl: './import-report-display.component.html',
    styleUrls: [
        './import-report-display.component.scss',
    ],
    standalone: false,
})
export class ImportReportDisplayComponent {

    @Input() public erzeugungsanlagenImportReport: ErzeugungsanlagenImportReport;

    constructor() {
    }

    private static countTransformationLogType(report: ErzeugungsanlagenImportReport, logType: string) {
        let count = 0;
        if (report) {
            for (const transformation of report.transformations) {
                for (const log of transformation.log) {
                    if (log.type === logType) {
                        count++;
                    }
                }
            }
        }
        return count;
    }

    private static countImportLogType(report: ErzeugungsanlagenImportReport, logType: string) {
        let count = 0;
        if (report) {
            for (const log of report.log) {
                if (log.type === logType) {
                    count++;
                }
            }
        }
        return count;
    }

    getNumberOfWarnings(): number {
        return this.getNumberOfImportWarnings() + this.getNumberOfTransformationWarnings();
    }

    areLogsPresent(): boolean {
        return (this.getNumberOfTransformationWarnings() > 0 ||
            this.getNumberOfTransformationErrors() > 0 ||
            this.getNumberOfImportErrors() > 0 ||
            this.getNumberOfImportWarnings() > 0);
    }

    // returns the total number of Warning within the transformations
    public getNumberOfTransformationWarnings(): number {
        return ImportReportDisplayComponent.countTransformationLogType(this.erzeugungsanlagenImportReport, 'WarningTransformationLogItem');
    }

    // returns the total number of Errors within the transformations
    public getNumberOfTransformationErrors(): number {
        return ImportReportDisplayComponent.countTransformationLogType(this.erzeugungsanlagenImportReport, 'ErrorTransformationLogItem');
    }

    // returns the total number of Errors within the transformations
    public getNumberOfImportErrors(): number {
        return ImportReportDisplayComponent.countImportLogType(this.erzeugungsanlagenImportReport, 'ErrorImportLogItem');
    }

    // returns the total number of Errors within the transformations
    public getNumberOfImportWarnings(): number {
        return ImportReportDisplayComponent.countImportLogType(this.erzeugungsanlagenImportReport, 'WarningImportLogItem');
    }

}


